<template>
  <b-modal 
    size="lg"
    ref="modal" 
    ok-only
    :title="$t('stores.quick-checkin.title')"
    :body-class="['text-center', doLocate ? 'bg-info text-white' : '' ]"
  >
    <BarcodeListener @input="next($event)" />

    <div>
      <p>{{$t(text)}}</p>
      <i class='bx display-1' :class="icon" ></i>

      <div class="alert alert-danger mt-4" role="alert" v-if="error">
        {{ $t(error.message || 'common.errors.unknown-error', error.params) }}
      </div>

      <b-container class="text-left" v-if="checkedIn.length">
        <b-row>
          <b-col cols="12">
            <h5>{{$t('stores.quick-checkin.checked-in',{count: checkedIn.length})}}</h5>
          </b-col>
          <b-col v-for="(item,i) in checkedIn" :key="i" cols="12" lg="6">
            <package-info v-bind="{item}" :locker-numbers="hasInventory" />
          </b-col>
        </b-row>
      </b-container>
      
    </div>

    <template #modal-footer>
      <b-button :disabled="working" @click="close()">{{$t('common.close')}}</b-button>
    </template>
  </b-modal>
</template>

<script>
import Modal from "@/components/Modal";
import BarcodeListener from '@/services/BarcodeListener';
import api from '@/api';
import PackageInfo from '../PackageInfo.vue';
import Package from "@/resources/Package.js";
import { vibrate } from "@/utils.js";

export default {
  name: 'QuickCheckinModal',
  extends: Modal,
  components: {
    BarcodeListener,
    PackageInfo
  },
  props: {
    namespace: {
      type: String,
      required: true,
    },
    locationId: {
      type: Number,
      required: true,
    },
    hasInventory: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Package,
      default: null,
    },
    chain: {
      type: Boolean,
      default: true,
    },
    checkExisting: {
      type: Function,
      default: () => null,
    }
  },
  data() {
    return {
      working: false,
      doLocate: this.item && this.hasInventory,
      checkedIn: [],
      error: null
    }
  },
  computed: {
    text() {
      if(this.working) {
        return this.$t('stores.quick-checkin.checking-in')
      } else if(this.doLocate) {
        return this.$t('stores.quick-checkin.awaiting-bin')
      } else {
        return this.$t('stores.quick-checkin.awaiting-input')
      }
    },
    icon() {
      return [
        this.doLocate ? 'bx-grid-alt' : 'bxs-package',
        this.working ? 'bx-burst' : 'bx-flashing',
      ]
    }
  },
  methods:{
    async next(barcode){
      if(false || this.working || !barcode) return
      this.working = true
      this.error = null

      try {
        if(this.doLocate) {
          const item = await this.locate(barcode)
          this.item = item
          this.checkedIn.unshift(this.item)
          this.doLocate = false
        } else {
          const item = await this.checkin(barcode)
          this.item = item

          this.doLocate = this.hasInventory && this.item


          this.doLocate || this.checkedIn.unshift(this.item)
        }

        if(!this.chain) {
          this.close()
        }
      } catch ({response: {data}}) {
        vibrate()
        this.error = data
      } finally {
        this.working = false
      }
    },
    async checkin(barcode) {
        const existing = this.checkExisting(barcode)

        if(existing) {
          return existing
        }

        const {data: {data: item}} = await api.put(`${this.namespace}/${this.locationId}/quick-checkin/${barcode}`,null,{
          suppress: [404,403]
        })

        return item
    },
    async locate(barcode) {
        const {data: {data: item}} = await api.put(`${this.namespace}/${this.locationId}/locate/${this.item.id}/${barcode}`,null,{
          suppress: [422]
        })

        return item
    }
  }
}
</script>